import React, { Component } from "react";

class MiniPopup extends Component {
  render() {
    const { iconClass, title, text, onClick, isDeactivated } = this.props;

    return (
      <li className={`miniPopup-button ${isDeactivated ? "deactivated" : ""}`}>
        <i className={iconClass} onClick={isDeactivated ? null : onClick} />
        <div className="miniPopup">
          {title && <div className="miniPopup-title">{title}</div>}
          {text && <div className="miniPopup-text">{text}</div>}
        </div>
      </li>
    );
  }
}

export default MiniPopup;



// WEBPACK FOOTER //
// ./src/components/Modals and Popovers/MiniPopup.js